import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { EditFormComponent } from './edit-form/edit-form.component';
import { ListModule } from '../../list/list.module';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormComponent } from './form/form.component';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead'
import { RlControlsModule } from './rl-controls/rl-controls.module';
import { FileModule } from '../file/file.module';
import { FloatFormComponent } from './float-form/float-form.component';
import { InputNumberTextDirective } from './shared/input-number-text.directive';




@NgModule({
  declarations: [EditFormComponent, FormComponent, FloatFormComponent, InputNumberTextDirective],
  imports: [
    SharedModule,
    ReactiveFormsModule,
    ListModule,
    BrowserAnimationsModule,
    BsDatepickerModule.forRoot(),
    TypeaheadModule.forRoot(),
    RlControlsModule,
    FileModule
  ],
  exports : [
    EditFormComponent,
    FloatFormComponent,
    InputNumberTextDirective
  ]
})
export class FormsModule { }
